//// Vendors ////
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import AOS from 'aos';
import Glide from '@glidejs/glide';

//// SITE functions ////
//import { sitePreloader } from './components/_site-preloader';

//// Site header ////
import { siteheaderScroll } from './components/_siteheader-scroll';

//// Menus ////
import { menuMain } from './components/_menu-main';
//import { menuMobile } from './components/_menu-mobile';

//// FLX ////
import { flxStats } from './components/_flx-stats';

// DOM ready first
document.addEventListener(
    'DOMContentLoaded',
    function () {
        // Alpine + Glide globals
        window.Alpine = Alpine;
        window.Glide = Glide;
        Alpine.plugin(collapse);
        Alpine.plugin(focus);
        Alpine.start();
        window.AOS = AOS;

        // Site header
        siteheaderScroll();

        // Menus
        menuMain();
        //menuMobile();

        // FLX
        flxStats();

        // AOS
        AOS.init({
            duration: 800,
            offset: 32,
            startEvent: 'load'
        });
    },
    false
);

// window.load next
//window.addEventListener('load', sitePreloader);
